import { FC } from 'react'
import Button, { ButtonProps } from 'components/features/pfm/Button/Button'
import { Omit } from 'interfaces'
import { WithComposeId } from 'interfaces/feed'
import { useComposeState } from 'helpers/hookHelpers'

type ComposeSubmitButtonProps =
  & Omit<ButtonProps, 'isSubmitting'>
  & WithComposeId

export const ComposeSubmitButton: FC<ComposeSubmitButtonProps> = (props) => {
  const { composeId, ...restProps } = props

  const { isSubmitting } = useComposeState(composeId, { isSubmitting: false })

  return (
    <Button
      { ...restProps }
      isSubmitting={ isSubmitting }
      disabled={ isSubmitting }
    />
  )
}
